import useReveal from "@/hooks/useReveal";

/**
 * Wraps a block so it rises into place the first time it is seen.
 *
 * Deliberately small: 12px and 500ms. Motion here is meant to acknowledge that
 * something arrived, not to perform. Anything larger turns reading into
 * waiting.
 */
export default function Reveal({ children, delay = 0, className = "" }) {
  const [ref, shown] = useReveal();
  return (
    <div
      ref={ref}
      className={`transition-all duration-500 ease-out ${
        shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
      } ${className}`}
      style={{ transitionDelay: shown ? `${delay}ms` : "0ms" }}
    >
      {children}
    </div>
  );
}
